export default __webpack_public_path__ + "static/media/buttonClick.e1ddeea1.mp3";